import React from "react";
import { Box, Grid } from "@mui/material";
import Container from "@mui/system/Container";
import { Button, Typography } from "@mui/material";
import promotion_icon from "./Images/promotion_icon.png";
import arrow_right from "./Images/arrow-right.png";
import dollar from "./Images/dollar.png";
import use from "./Images/use.png";
import "./style.css";
import { usePromotionMutation } from "api/promotions";
function Promotion() {
  const [usepromotion, { isLoading }] = usePromotionMutation();

  const handleUsePromotion = (id) => {
    usepromotion({ id });
  };

  return (
    <>
      {/* <FilterNavbar/> */}
      <Container sx={{ display: "flex" }} maxWidth>
        <Container
          sx={{
            padding: 5,
          }}
          maxWidth="xl"
        >
          <Typography
            sx={{
              fontFamily: "Outfit",
              fontWeight: "600",
              fontSize: { lg: "24px", md: "24px", sm: "18px", xs: "18px" },
            }}
          >
            Promotions
          </Typography>

          <Container
            sx={{
              height: "94px",
              backgroundColor: "#F0FAF9;",
              borderRadius: "4px",
              marginTop: 1,
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
            }}
            maxWidth="xl"
          >
            <Box>
              <Box sx={{ display: "flex", alignItems: "center" }}>
                <img src={promotion_icon} />

                <Typography
                  sx={{
                    fontFamily: "Outfit",
                    fontSize: {
                      lg: "24px",
                      md: "24px",
                      sm: "18px",
                      xs: "18px",
                    },
                    fontWeight: "600",
                    marginLeft: 1,
                  }}
                >
                  Have a promotion code?
                </Typography>
              </Box>
              <Box>
                <Typography
                  sx={{
                    fontFamily: "Outfit",
                    fontSize: {
                      lg: "16px",
                      md: "16px",
                      sm: "14px",
                      xs: "14px",
                    },
                    fontWeight: "400",
                    color: "#2B817B;",
                    marginLeft: 4,
                  }}
                >
                  Enter your promo code to redeem it
                </Typography>
              </Box>
            </Box>
            <Box>
              <Button>
                <img src={arrow_right} />
              </Button>
            </Box>
          </Container>

          <Grid container spacing={2}>
            {[...Array(4)].map(() => (
              <Grid item sm={12} sx={12} md={12} lg={6}>
                <Box
                  sx={{
                    width: "100%",
                    height: "181px",
                    backgroundColor: "#2B817B",
                    borderRadius: "4px",
                    padding: 2,
                    display: "flex",
                    justifyContent: "space-between",
                    marginTop: 2,
                  }}
                  className="promotionCard"
                >
                  <Box>
                    <Typography
                      sx={{
                        fontFamily: "Outfit",
                        fontSize: {
                          lg: "20px",
                          md: "20px",
                          sm: "16px",
                          xs: "16px",
                        },
                        fontWeight: "600",
                        color: "white",
                      }}
                    >
                      Get off order
                    </Typography>
                    <Typography
                      sx={{
                        fontFamily: "Outfit",
                        fontSize: {
                          lg: "32px",
                          md: "32px",
                          sm: "24px",
                          xs: "24px",
                        },
                        fontWeight: "600",
                        color: "white",
                      }}
                    >
                      $ 150.00
                    </Typography>
                    <Typography
                      sx={{
                        fontFamily: "Outfit",
                        fontSize: {
                          lg: "16px",
                          md: "16px",
                          sm: "14px",
                          xs: "14px",
                        },
                        fontWeight: "400",
                        color: "white",
                        marginTop: 2,
                        border: "1px solid white",
                        display: "inline-block",
                        borderRadius: "5px",
                        padding: "5px",
                      }}
                    >
                      Valid until 20 Oct
                    </Typography>
                  </Box>
                  <Box
                    sx={{
                      display: "flex",
                      flexDirection: "column",
                      justifyContent: "space-between",

                      alignItems: "center",
                    }}
                  >
                    <Box>
                      <img src={dollar} />
                    </Box>
                    <Button onClick={() => handleUsePromotion("id")}>
                      <img src={use} />
                    </Button>
                  </Box>
                </Box>
              </Grid>
            ))}
          </Grid>
        </Container>
      </Container>
    </>
  );
}

export default Promotion;
